import { env } from "process";
import "../../../utils/messages";
import { TICKET_MESSAGES } from "../../../utils/messages";
import { ClientMessage } from "../../../utils/objects";
import qs from 'querystring';

export function assignTicketRequests(api) {
    /****************************************ASSISTANCE REQUESTS*********************************************************/
    let ticketsBaseURL_remote = process.env.VUE_APP_BASE_URL_REMOTE + "/enterprise/tickets";
    let ticketsBaseURL_one = process.env.VUE_APP_BASE_URL + "/enterprise/tickets";

    api.createTicket = async function (request) {
        var clientMessage = ClientMessage.success(TICKET_MESSAGES.CREATED);

        var response = await api.post(
            ticketsBaseURL_remote + "/generate",
            JSON.stringify(request),
            this.buildConfig()
        ).then(res => 200 <= res.status && res.status <= 300).catch(e => {
            clientMessage = this.checkError(e, TICKET_MESSAGES.NOT_CREATED);
            return false;
        });

        this.createToastFunction(this.translateFunction(clientMessage.text), clientMessage.msgType);

        return response;
    }

    api.getTickets = async function (filters) {
        var queryString = filters != null ? '?' + qs.stringify(filters) : '';

        var response = await api.get(ticketsBaseURL_one + queryString, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, TICKET_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.getTicket = async function (ticketID) {
        var response = await api.get(ticketsBaseURL_one + '/' + ticketID, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, TICKET_MESSAGES.NOT_RETRIEVED);
                return null;
            });

        return response;
    }

    api.deleteTicket = async function (ticketID, ticketName) {
        var clientMessage = ClientMessage.success(TICKET_MESSAGES.DELETED, { 0: ticketName });

        var response = await api.delete(ticketsBaseURL_one + '/' + ticketID, this.buildConfig())
            .then(res => 200 <= res.status && res.status <= 299)
            .catch(e => {
                clientMessage = this.checkError(e, TICKET_MESSAGES.NOT_DELETED, { 0: ticketName });
                return false;
            });

        this.createToastFunction(this.translateFunction(clientMessage.text, { 0: ticketName }), clientMessage.msgType);

        return response;
    }

    api.getTicketsByIDRemote = async function (idRemote) {
        var queryString = filters != null ? '?' + qs.stringify(filters) : '';

        var response = await api.get(ticketsBaseURL_one + "/idr/" + idRemote, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, TICKET_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    /*
    Si può passare anche un oggetto parziale, per modificare solo determinati campi, come lo stato.
    Ovviamente l'id del ticket è sempre obbligatorio all'interno dell'oggetto passato
    */
    api.editTicket = async function (ticketID, request) {
        var clientMessage = ClientMessage.success(TICKET_MESSAGES.MODIFIED);

        var response = await api.put(
            ticketsBaseURL_remote + "/" + ticketID,
            JSON.stringify(request),
            this.buildConfig()
        ).then(res => 200 <= res.status && res.status <= 300).catch(e => {
            clientMessage = this.checkError(e, TICKET_MESSAGES.NOT_MODIFIED);
            return false;
        });

        this.createToastFunction(this.translateFunction(clientMessage.text), clientMessage.msgType);

        return response;
    }

    api.linkSessionToTicket = async function (ticketID, idSession) {
        var body = { id_session: idSession };

        var response = await api.post(
            ticketsBaseURL_one + '/' + ticketID + '/link-session',
            JSON.stringify(body),
            this.buildConfig()
        ).then(res => {
            if (res.status == 400) return null;
            return res.data;
        }).catch(e => {
            this.checkError(e, TICKET_MESSAGES.SESSION_NOT_LINKED);
            return null;
        });

        return response;
    }

    api.pollTickets = async function () {
        var response = await api.get(ticketsBaseURL_one + '/poll', this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, TICKET_MESSAGES.POLL_FAILED, null, false);
                return [];
            });

        return response;
    }
}
